export const APP_PREFIX = 'WIND';
export const GLOBAL_AJAX_TIMEOUT = 3000;
